// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".flex-fit-content[data-v-20c8ed98] {\n  flex: 1 1 auto;\n}\n.form-group-row[data-v-20c8ed98] {\n  gap: 2rem;\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n}\n.form-group-row label[data-v-20c8ed98] {\n  font-weight: 500;\n  margin-bottom: 0px;\n}\n.form-group-row select[data-v-20c8ed98] {\n  max-width: 150px;\n}", ""]);
// Exports
module.exports = exports;
